//INITIAL FLOW
import * as types from "./actionTypes";

export const setFabricatorSubscriptions = (fabricatorSubscriptions) => ({
  type: types.SET_FABRICATOR_SUBSCRIPTIONS,
  payload: {fabricatorSubscriptions}
});

export const setInitialFlowAdditionalRooms = (initialFlowAdditionalRooms) => ({
  type: types.SET_INITIAL_FLOW_ADDITIONAL_ROOMS,
  payload: {initialFlowAdditionalRooms}
});

export const setInitialFlowType = (initialFlowType) => ({
  type: types.SET_INITIAL_FLOW_BUTTON,
  payload: {initialFlowType}
});

export const setInitialFlowRoom = (initialFlowRoom) => ({
  type: types.SET_INITIAL_FLOW_ROOM,
  payload: {initialFlowRoom}
});

export const setInitialFlowVisualizerNotAvailable = (visualizerNotAvailable) => ({
  type: types.SET_INITIAL_FLOW_VISUALIZER_NOT_AVAILABLE,
  payload: {visualizerNotAvailable}
});

export const setInitialFlowFinished = (initialFlowFinished) => ({
  type: types.SET_INITIAL_FLOW_FINISHED,
  payload: {initialFlowFinished}
});

export const setInitialFlowRoomLayout = (initialFlowRoomLayout) => ({
  type: types.SET_INITIAL_FLOW_ROOM_LAYOUT,
  payload: {initialFlowRoomLayout}
});
export const setInitialFlowStep = (initialFlowStep) => ({
  type: types.SET_INITIAL_FLOW_STEP,
  payload: {initialFlowStep}
});
